/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Transfer_Dialog_Confirm_MoveInputs */



/**
* | output |
* | --- |
* | "Move" |
*
* @param {Transfer_Dialog_Confirm_MoveInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const transfer_dialog_confirm_move = /** @type {((inputs?: Transfer_Dialog_Confirm_MoveInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Transfer_Dialog_Confirm_MoveInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Verschieben")
	return /** @type {LocalizedString} */ ("Move")
});